import Vue from 'vue'
export const mutations = {
    setFooterState(state, data) {
        Vue.set(state, 'footer', data);
    }
};
